export const messages = {
  required: 'Eingabe erforderlich',
  email: 'Ungültige E-Mail-Adresse',
  date: 'Ungültiges Datum',
  wrongDateFormat: 'Ungültiges Datumsformat',
  url: 'Ungültige URL (Beispiel für eine korrekte URL: http://mylocation.at)',
  minlength: 'Eingabe ist zu kurz',
  maxlength: 'Eingabe ist zu lang',
  min: 'Eingabe kleiner Minimum',
  max: 'Eingabe größer Maximum',
  even: 'Eingabe muss eine gerade Zahl sein',
  phone: 'Ungültige Telefonnummer (Ländervorwahl ist erforderlich: z.B. +4312180275)',

  password: 'Passwort entspricht nicht den Passwortrichtlinien',
  matchingField: 'Die Eingaben stimmen nicht überein'
};

export function message(key: string): string {
  const result = messages[key] || key;
  return result;
}
